import React from 'react';
import { Loader2 } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';

const ProfileSettingsForm = ({ 
  profile, 
  setProfile, 
  passwordData, 
  setPasswordData, 
  text, 
  onProfileSubmit, 
  onPasswordSubmit, 
  isUpdatingProfile, 
  isChangingPassword 
}) => {
  return (
    <div className="space-y-6">
      {/* Profile Form */}
      <div className="bg-white rounded-2xl shadow-sm p-6">
        <h2 className="font-serif text-xl font-semibold text-[#1A252C] mb-6">
          {text.profile}
        </h2>
        
        <form onSubmit={onProfileSubmit} className="space-y-4">
          <div className="grid sm:grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label>{text.firstName}</Label>
              <Input
                value={profile.first_name || ''}
                onChange={(e) => setProfile({...profile, first_name: e.target.value})}
                className="rounded-xl"
              />
            </div>
            <div className="space-y-2">
              <Label>{text.lastName}</Label>
              <Input
                value={profile.last_name || ''}
                onChange={(e) => setProfile({...profile, last_name: e.target.value})}
                className="rounded-xl"
              />
            </div>
          </div>
          
          <div className="space-y-2">
            <Label>{text.email}</Label>
            <Input
              value={profile.email || ''}
              disabled
              className="rounded-xl bg-[#F0F4F8]"
            />
          </div>
          
          <div className="space-y-2">
            <Label>{text.phone}</Label>
            <Input
              value={profile.phone || ''}
              onChange={(e) => setProfile({...profile, phone: e.target.value})}
              className="rounded-xl"
            />
          </div>
          
          <div className="space-y-2">
            <Label>{text.address}</Label>
            <Input
              value={profile.address || ''}
              onChange={(e) => setProfile({...profile, address: e.target.value})}
              className="rounded-xl"
            />
          </div>
          
          <div className="grid sm:grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label>{text.city}</Label>
              <Input
                value={profile.city || ''}
                onChange={(e) => setProfile({...profile, city: e.target.value})}
                className="rounded-xl"
              />
            </div>
            <div className="space-y-2">
              <Label>{text.postalCode}</Label>
              <Input
                value={profile.postal_code || ''}
                onChange={(e) => setProfile({...profile, postal_code: e.target.value})}
                className="rounded-xl"
              />
            </div>
          </div>
          
          <Button
            type="submit"
            disabled={isUpdatingProfile}
            className="primary-btn rounded-full"
          >
            {isUpdatingProfile ? <Loader2 className="w-4 h-4 animate-spin" /> : text.saveChanges}
          </Button>
        </form>
      </div>

      {/* Password Change */}
      <div className="bg-white rounded-2xl shadow-sm p-6">
        <h2 className="font-serif text-xl font-semibold text-[#1A252C] mb-6">
          {text.changePassword}
        </h2>
        
        <form onSubmit={onPasswordSubmit} className="space-y-4">
          <div className="space-y-2">
            <Label>{text.currentPassword}</Label>
            <Input
              type="password"
              value={passwordData.current_password}
              onChange={(e) => setPasswordData({...passwordData, current_password: e.target.value})}
              className="rounded-xl"
            />
          </div>
          
          <div className="grid sm:grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label>{text.newPassword}</Label>
              <Input
                type="password"
                value={passwordData.new_password}
                onChange={(e) => setPasswordData({...passwordData, new_password: e.target.value})}
                className="rounded-xl"
              />
            </div>
            <div className="space-y-2">
              <Label>{text.confirmPassword}</Label>
              <Input
                type="password"
                value={passwordData.confirm_password}
                onChange={(e) => setPasswordData({...passwordData, confirm_password: e.target.value})}
                className="rounded-xl"
              />
            </div>
          </div>
          
          <Button
            type="submit"
            disabled={isChangingPassword}
            className="primary-btn rounded-full"
          >
            {isChangingPassword ? <Loader2 className="w-4 h-4 animate-spin" /> : text.updatePassword}
          </Button>
        </form>
      </div>
    </div>
  );
};

export default ProfileSettingsForm;
